import { Route } from 'types/route.type';

import { routes as farmOverview } from './features/farm-overview/routes';
import { routes as registrationLog } from './features/registration-log/routes';
import { routes as farmSetup } from './features/farm-setup/routes';

export const routes: Route[] = [...farmOverview, ...registrationLog, ...farmSetup];
